function tuto(ctx) {

	ctx.allowInteraction = false;
  
	let firstNode = ctx.timeline.songs.all.find(song => {
		return song.n_children > 0 && song.cover_ids.length > 0;
	});

	const tour = ctx.$shepherd({
		useModalOverlay: true,
		defaultStepOptions: {
			scrollTo: {behavior: "smooth", block: "center", inline: "center"},
			modalOverlayOpeningPadding: 4,
			arrow: true,
			canClickTarget: true,
			cancelIcon: {
				enabled: ctx.skippableTuto
			}
		}
	});

	tour.on("complete", () =>  {
		ctx.onTutoEnd();
	});

	tour.on("cancel", () =>  {
		ctx.onTutoEnd();
	});
  
	const buttons = [
		{
			text: "Previous",
			action: tour.back,
			classes: "button is-light"
		},
		{
			text: "Next",
			action: tour.next,
			classes: "button is-primary"
		}
	];
  
	const lists = ctx.$refs.lists.sortedData;

	tour.addStep({
		text: "Welcome to Muzlink: an interactive tool for exploring inspirational and collaborative relationships between artists.",
		buttons: [{
			text: "Next",
			action: tour.next,
			classes: "button is-primary"
		}]
	});
  
	tour.addStep({
		text: `The following graph presents the different roles occupied by ${ctx.artist.name} during his career.`,
		buttons: buttons,
		attachTo: {
			element: ".artist-stat-2",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `This timeline shows the productions of the artist ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#timeline-1",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Here are displayed the <b>original productions and adaptations</b> produced by the artist ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: ".nodes-1",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `On the far right are displayed the <b>covers</b> sung by the artist ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: ".covers-own",
			on: "top"
		},
		showOn () {
			return document.getElementsByClassName("covers-own")[0].childNodes.length > 0;
		}
	});
  
	tour.addStep({
		text: `On this timeline are represented the <b>inspirations</b> of ${ctx.artist.name}, that is to say the songs at the origin of adaptations or covers produced by ${ctx .artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#timeline-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `This timeline shows the <b>songs influenced</b> by the artist ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#timeline-2",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Here are displayed the <b>adaptations</b> from the productions of the artist ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: ".nodes-2",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `On the far right are displayed the <b>covers</b> from the productions of the artist ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: ".covers-target",
			on: "top"
		},
		showOn () {
			return document.getElementsByClassName("covers-target")[0].childNodes.length > 0;
		}
	});
  
	tour.addStep({
		text: `Here we see the artists who <b>most often inspired</b> the artist ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#list-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `In first position, we find <b>${lists[0].data [0].artist.name}</b>, with ${lists[0].data[0].scores[0].total} implications.`,
		buttons: buttons,
		attachTo: {
			element: "#list-0 .item-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Here, we see the artists who <b>have collaborated most often</b> with ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#list-1",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `In first position, we find <b>${lists[1].data[0].artist.name}</b>, with ${lists[1].data[0].scores[1].total} implications.`,
		buttons: buttons,
		attachTo: {
			element: "#list-1 .item-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Here it is possible to see the artists who <b>have most often been influenced</b> by ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#list-2",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `In first position, we find <b>${lists[2].data[0].artist.name}</b>, with ${lists[2].data[0].scores[2].total} implications.`,
		buttons: buttons,
		attachTo: {
			element: "#list-2 .item-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: "You can filter & sort the artists by role: author, composer or interpreter",
		buttons: buttons,
		attachTo: {
			element: "#list-2 .artist-list-header .icons",
			on: "top"
		}
	});
  
	tour.addStep({
		text: "You can search for a specific song using the <b>search bar</b>.",
		buttons: buttons,
		attachTo: {
			element: "#song-search",
			on: "bottom"
		}
	});
  
	tour.addStep({
		text: "When you <b>click on a song</b>, a description sheet with additional information appears.",
		buttons: buttons,
		attachTo: {
			element: `#node-${firstNode.id}`,
			on: "top"
		},
		beforeShowPromise: () => {
			ctx.selectedSong = firstNode;
		}
	});
  
	tour.addStep({
		text: `We notice here that the song <b>${firstNode.label}</b> was adapted ${firstNode.n_children} times and covered ${firstNode.cover_ids.length} times.`,
		buttons: [
			{
				text: "Previous",
				action: tour.back,
				classes: "button is-light"
			},
			{
				text: "Finish",
				action: tour.next,
				classes: "button is-primary"
			}
		],
		attachTo: {
			element: ".timeline-tree-container",
			on: "top"
		}
	});

	tour.start();
}

export default tuto;
